import { createClient, UnpagedSearchOperation, unpagedSearchRequestFactory } from '@infuse/api/common';

const client = createClient('/rest/operator-api/properties');

export type ApiResponse = {
  [propertyName: string]: CpmsProperty[];
};

export interface CpmsProperty {
  key: string;
  value: string;
}

export const cpmsPropertyPermissions = {
  GET: 'cpms.get-properties'
};

export const getCpmsProperties: UnpagedSearchOperation<ApiResponse> = unpagedSearchRequestFactory<ApiResponse>(client, {
  permissionId: cpmsPropertyPermissions.GET
});
